import { FaceMeasurements } from '@ca/common/types'
import { useOrderState } from '@order/hooks/useOrderState'
import { trpc } from 'api'
import useSession from 'hooks/useSession'
import { useCallback } from 'react'

const getShape = (data: {
  extend_x?: string | null
  extend_y?: string | null
}) => {
  return {
    extend_x: Number(data.extend_x) || 0,
    extend_y: Number(data.extend_y) || 0,
  }
}

export type OnSaveCb = (frameId: string | number) => void

export const useSaveFrame = ({
  onSuccess,
  onMutate,
}: {
  onSuccess?: OnSaveCb
  onMutate?: OnSaveCb
}) => {
  const utils = trpc.useUtils()
  const updateFrame = useOrderState((s) => s.updateFrame)
  const { staff, customer, store } = useSession()
  const staffId = staff?.data?.id
  const customerId = customer?.data?.id

  const query = trpc.frames.customer.save.useMutation({
    onMutate: (data) => {
      if (!data.frame_id) return
      updateFrame(Number(data.frame_id), {
        // FIXME: Maybe we could have better type here?
        measurement: (data.measurement as FaceMeasurements) ?? undefined,
        shape: getShape(data),
      })
      onMutate?.(data.frame_id)
    },

    onSuccess: (data) => {
      if (!data.frame_id) return
      utils.frames.customer.list.invalidate()
      onSuccess?.(data.frame_id)
    },
  })

  const save = useCallback(
    ({
      frameId,
      measurement,
      extend_x,
      extend_y,
    }: {
      frameId: string | number
      measurement?: FaceMeasurements | null
      extend_x?: string | null
      extend_y?: string | null
    }) => {
      if (!customerId) return

      query.mutate({
        frame_id: `${frameId}`,
        customer_id: customerId.toString(),
        store_id: store?.data?.ref,
        staff_id: staffId ? `${staffId}` : undefined,
        measurement: measurement,
        extend_x,
        extend_y,
      })
    },
    [customerId, query, staffId, store]
  )

  return {
    query,
    save,
  }
}

export default useSaveFrame
